export default __webpack_public_path__ + "beta-maps-guides-outdoors-1200-ec1741ca2ab6de790b5a4d59d0f1c230.webp";